import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import H3Text from '@Uilib/h3Text';
import ProductActions from '@Actions/productActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import BulkUploadForm from './BulkUploadForm';
import BulkProductPreview from './BulkProductPreview';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
/**
 *
 */
const BulkUpload = ({
  onBulkUpload, setCreateNewBatch, createNewBatch, disabled, userDepartmentId, customClass,
  selectedSeller, disableBatchCreate, adjustmentType,
}) => {
  const [visibleUpload, setVisibleUpload] = useState(false);
  const [data, setData] = useState([]);
  const [visibleProductPreview, setVisibleProductPreview] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
  }, []);

  const handleDelete = (key) => {
    const copyData = data.filter((item) => item.key !== key);
    setData(copyData);
  };

  return (
    <Fragment>
      <div
        className={`${customClass} ${disabled ? 'disabled-button' : ''}`}
        onClick={() => {
          if (!disabled) {
            setVisibleUpload(true);
          }
        }}
      >
        <FontAwesomeIcon icon={faPlusCircle} />
        &nbsp;
        Upload Items
      </div>

      <Drawer
        open={visibleUpload}
        onClose={() => setVisibleUpload(false)}
        showHeader
        width="650px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '597px' }}>
            <H3Text text="Upload Products" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setVisibleUpload(false)} />
          </div>
        </div>
        <BulkUploadForm
          onBulkUpload={(updatedData, copyFileData) => onBulkUpload(updatedData, copyFileData)}
          setCreateNewBatch={setCreateNewBatch}
          createNewBatch={createNewBatch}
          userDepartmentId={userDepartmentId}
          callback={() => setVisibleProductPreview(true)}
          selectedSeller={selectedSeller}
          disableBatchCreate={disableBatchCreate}
          setData={setData}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          adjustmentType={adjustmentType}
        />
        <Drawer
          open={visibleProductPreview}
          onClose={() => setVisibleProductPreview(false)}
          showHeader
          width="650px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '597px' }}>
              <H3Text text="Verify Products" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setVisibleProductPreview(false)} />
            </div>
          </div>
          <BulkProductPreview
            data={data}
            onBulkUpload={(updatedData, copyFileData) => onBulkUpload(updatedData, copyFileData)}
            handleDelete={handleDelete}
            filteredData={filteredData}
            callback={() => {
              setVisibleProductPreview(false);
              setVisibleUpload(false);
            }}
            adjustmentType={adjustmentType}

          />
        </Drawer>
      </Drawer>

    </Fragment>
  );
};

const mapStateToProps = ({ /* Import Reducers here */ UserReducers, ProductReducers }) => ({
  user: UserReducers.user,
  getProductBySkusLoading: ProductReducers.getProductBySkusLoading,
});

const mapDispatchToProps = (/* Import actions here */ dispatch) => ({

});

BulkUpload.propTypes = {
  createNewBatch: PropTypes.func,
  setCreateNewBatch: PropTypes.func,
  onBulkUpload: PropTypes.func,
  disabled: PropTypes.bool,
  selectedSeller: PropTypes.any,
  userDepartmentId: PropTypes.any,
  disableBatchCreate: PropTypes.bool,
  adjustmentType: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkUpload));
